'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/diagnostics/client';

export default function Error({
  error,
  reset,
}: {
  error?: Error & { digest?: string };
  reset?: () => void;
}) {
  useEffect(() => {
    if (error) {
      console.error(error);
      reportClientError(error, 'boundary');
    }
  }, [error]);

  const handleReset = () => {
    if (typeof reset === 'function') {
      try {
        reset();
      } catch {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }
    } else if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white p-8 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold mb-4">Something went wrong</h2>
      <button
        onClick={handleReset}
        className="btn btn-primary btn-md"
      >
        Try again
      </button>
    </div>
  );
}
